import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const MRN_SETTINGS_ENDPOINT = `${config.api.url}/organization/mrn-settings`;

const formatApiErrorValue = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.filter(Boolean).join(' ');
  return JSON.stringify(value);
};

const handleSettingsResponse = async (res) => {
  if (res.ok) return handleResponse(res);

  const errorText = await res.text();
  let errorData = null;
  try {
    errorData = errorText ? JSON.parse(errorText) : null;
  } catch {
    errorData = null;
  }

  const validationErrors = errorData?.errors && typeof errorData.errors === 'object'
    ? Object.values(errorData.errors).flat().filter(Boolean).join(' ')
    : '';
  const message = (
    formatApiErrorValue(errorData?.message) ||
    formatApiErrorValue(errorData?.error) ||
    validationErrors ||
    errorText ||
    `HTTP error! status: ${res.status}`
  );

  const error = new Error(message);
  error.status = res.status;
  error.statusText = res.statusText;
  if (errorData?.errors && typeof errorData.errors === 'object') {
    error.fieldErrors = errorData.errors;
  }
  throw error;
};

const appendPreviewParam = (params, key, value) => {
  if (value === undefined || value === null) return;
  params.set(key, String(value));
};

const mrnSettingsApi = {
  getSettings: async () => {
    const res = await fetch(MRN_SETTINGS_ENDPOINT, {
      headers: getAuthHeaders(),
    });
    return handleResponse(res);
  },

  updateSettings: async (settings) => {
    const res = await fetch(MRN_SETTINGS_ENDPOINT, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(settings),
    });
    return handleSettingsResponse(res);
  },

  backfill: async ({ clients = false, newborns = false } = {}) => {
    const res = await fetch(`${MRN_SETTINGS_ENDPOINT}/backfill`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ clients, newborns }),
    });
    return handleSettingsResponse(res);
  },

  getPreview: async (settings = {}) => {
    const params = new URLSearchParams();
    appendPreviewParam(params, 'autoGenerateEnabled', settings.autoGenerateEnabled);
    appendPreviewParam(params, 'formatType', settings.formatType);
    appendPreviewParam(params, 'prefix', settings.prefix);
    appendPreviewParam(params, 'sequencePadding', settings.sequencePadding);
    appendPreviewParam(params, 'nextSequenceValue', settings.nextSequenceValue);
    appendPreviewParam(params, 'includeYear', settings.includeYear);
    appendPreviewParam(params, 'separator', settings.separator);

    const queryString = params.toString();
    const res = await fetch(
      `${MRN_SETTINGS_ENDPOINT}/preview${queryString ? `?${queryString}` : ''}`,
      { headers: getAuthHeaders() }
    );
    return handleResponse(res);
  },
};

export default mrnSettingsApi;
